import { render } from "./PageNotFound.vue?vue&type=template&id=450bd1d0"
const script = {}

import exportComponent from "/Users/bewinxed/Downloads/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__